import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------
// This app uses Amplify auth exclusively.
// JWT auth routes have been removed.
// ----------------------------------------------------------------------

const Amplify = {
  SignInPage: lazy(() => import('../../pages/auth/amplify/sign-in')),
  SignUpPage: lazy(() => import('../../pages/auth/amplify/sign-up')),
  VerifyPage: lazy(() => import('../../pages/auth/amplify/verify')),
  ResetPasswordPage: lazy(() => import('../../pages/auth/amplify/reset-password')),
  UpdatePasswordPage: lazy(() => import('../../pages/auth/amplify/update-password')),
};

const authAmplify = {
  path: 'amplify',
  children: [
    {
      path: 'sign-in',
      element: (
        <GuestGuard>
          <AuthSplitLayout>
            <Amplify.SignInPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'sign-up',
      element: (
        <GuestGuard>
          <AuthSplitLayout>
            <Amplify.SignUpPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'verify',
      element: (
        <GuestGuard>
          <AuthSplitLayout>
            <Amplify.VerifyPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'reset-password',
      element: (
        <GuestGuard>
          <AuthSplitLayout>
            <Amplify.ResetPasswordPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'update-password',
      element: (
        <GuestGuard>
          <AuthSplitLayout>
            <Amplify.UpdatePasswordPage />
          </AuthSplitLayout>
        </GuestGuard>
      ),
    },
  ],
};

// ----------------------------------------------------------------------

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [authAmplify],
  },
];
